import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../Api/APIURLS';
import { CommonAjaxGetRequestWithOutParams } from '../Api/CommonAjaxUtils';
import * as HERBUI from 'react-bootstrap'

function AIMSPendingPopup({ showpopup, handleClose }) {
    const [pendingData, setPendingData] = useState([])
    useEffect(() => {
        if (showpopup) {
            CommonAjaxGetRequestWithOutParams(BASE_URL + 'apgli/aims/pendingCount/alert').then((response) => {
                if (response !== '' && response !== null && response !== undefined) {
                    setPendingData(response)
                }
            })
        }
    }, [showpopup])
    return (
        <div>
            <HERBUI.Modal size='lg' show={showpopup}
                onHide={handleClose}
                scrollable={true}>
                <HERBUI.Modal.Header className="modal-header">
                    <HERBUI.Modal.Title>
                        <h5> Pending Alert <span style={{ color: "yellow" }}>⚠</span></h5>
                    </HERBUI.Modal.Title>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={handleClose}
                    ></button>
                </HERBUI.Modal.Header>
                <HERBUI.Modal.Body className="modal-body" >
                    {/* <div className='alert alert-info'>
                        <span style={{ color: "red" }}>Note :</span>
                        <span style={{ color: "black" }}>&nbsp;Hi APGLI Team,
                            Please review the Below message. If there are any pending applications, kindly complete them at the earliest to ensure smooth processing.
                        </span>
                    </div> */}
                    <HERBUI.Row >
                        <HERBUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}></HERBUI.Col>
                        <HERBUI.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                            <table
                                className="table table-bordered table-hover table-sm"
                                style={{
                                    fontSize: "13px",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    textAlign: "center",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
                                }}
                            >
                                <thead style={{ background: "#1E3770", color: "#fff", fontWeight: "600" }}>
                                    <tr>
                                        <th style={{ width: "10%" }}>S.No</th>
                                        <th style={{ textAlign: "left" }}>Request Type</th>
                                        <th style={{ width: "40%" }}>Pending Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td style={{ textAlign: "left" }}>Loans</td>
                                        <td>{pendingData.loansPending}</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td style={{ textAlign: "left" }}>Claims</td>
                                        <td>{pendingData.claimsPending}</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td style={{ textAlign: "left" }}>Death Claim</td>
                                        <td>{pendingData.deathPending}</td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td style={{ textAlign: "left" }}>Policy Holder Requests</td>
                                        <td>{pendingData.policyHolderReqs}</td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td style={{ textAlign: "left" }}>Beneficiary Updation Files</td>
                                        <td>{pendingData.beneficiaryUpdation}</td>
                                    </tr>
                                    <tr>
                                        <td>6</td>
                                        <td style={{ textAlign: "left" }}>Internal Service Requests</td>
                                        <td>{pendingData.internalServiceRes}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </HERBUI.Col>

                    </HERBUI.Row>


                </HERBUI.Modal.Body>
                <HERBUI.Modal.Footer className="modal-footer">
                    <HERBUI.Button className="btnClose btn-sm" onClick={handleClose}><b>Close </b></HERBUI.Button>
                </HERBUI.Modal.Footer>
            </HERBUI.Modal>
        </div>
    )
}

export default AIMSPendingPopup